import { render, staticRenderFns } from "./SignaturePad.vue?vue&type=template&id=404a1998&scoped=true&"
import script from "./SignaturePad.vue?vue&type=script&lang=ts&"
export * from "./SignaturePad.vue?vue&type=script&lang=ts&"
import style0 from "./SignaturePad.vue?vue&type=style&index=0&id=404a1998&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404a1998",
  null
  
)

export default component.exports